import styles from './CardHeader.module.css';

const CardHeader = props => {
	return (
		<h3 className={`${props.passOnClasses} ${styles.CardHeader}`}>{props.children}</h3>
	)
}

export default CardHeader;